import { createSelector } from 'reselect';

const selectActivityReportCommentState = () => (state) => state.get('activityreportcomment');

const selectorsPutActivityReportComment = () =>
    createSelector(selectActivityReportCommentState(), (substate) =>
        substate.get('selectorsPutActivityReportComment')
    );

export { selectorsPutActivityReportComment };
